// Dodanie załącznika do wątku czatu

import { orionAxios } from '../orionApi';
import { AddAttachmentRequest } from './orionTypes';

/**
 * Dodaje załącznik (plik) do wątku czatu
 * @param threadId - UUID wątku
 * @param data - dane pliku (nazwa, typ, rozmiar, zawartość w base64)
 * @returns UUID załącznika jako string
 */
export const addAttachment = async (
  threadId: string,
  data: AddAttachmentRequest
): Promise<string> => {
  const response = await orionAxios.post<string>(
    `/api/aiassistant/add-attachment/${threadId}`,
    data
  );
  return response.data;
};

